// extracted by mini-css-extract-plugin
var _1 = "pubEHKzRGPrvjCJBX2wK";
var _2 = "Pnm47DR8FYGCW8yTtD8Q";
export { _1 as "spinner", _2 as "spinner-animation" }
